import { Component } from '@angular/core';
import { DialogBaseComponent, DialogParams } from 'app/shared/dialog-base.component';
import { DomainService } from 'app/shared/domain.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

// Per-failure detail shown in the summary. Keeping this independent of the
// component's internal InvoicePostAction type so the dialog has no upstream
// coupling — the caller flattens whatever shape it has into these rows.
export interface BatchSummaryFailureRow {
  invoiceId: string;
  accountName: string;
  failedStep: string;
  error: string;
}

export interface BatchSummaryDialogParams extends DialogParams {
  successCount: number;
  failureCount: number;
  failures: BatchSummaryFailureRow[];
}

@Component({
  templateUrl: './batch-summary-dialog.component.html',
  standalone: false,
})
export class BatchSummaryDialogComponent extends DialogBaseComponent<BatchSummaryDialogParams> {
  successCount = 0;
  failureCount = 0;
  failures: BatchSummaryFailureRow[] = [];

  constructor(
    public config: DynamicDialogConfig<BatchSummaryDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService,
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      header: 'Batch Processing Summary',
      width: '640px',
      height: 'auto',
    });
    this.prepare();
  }

  prepare() {
    this.successCount = this.params.successCount;
    this.failureCount = this.params.failureCount;
    this.failures = this.params.failures;
    this.isPageReady = true;
  }

  close() {
    this.dialogRef.close();
  }
}
